import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { AppConfigurationClient, GetConfigurationSettingResponse } from '@azure/app-configuration';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService {

  constructor(private configSvc: ConfigService) { }

  async getFeatureFlag(featureName: string) {
    let client = new AppConfigurationClient(this.configSvc.configuration.appConfigurationConnectionString);
    const featureFlagKey = `.appconfig.featureflag/${featureName}`;
    const options = { key: featureFlagKey };
    const flag: GetConfigurationSettingResponse = await client.getConfigurationSetting(options, {
      requestOptions: {
        customHeaders: { 'cache-control': 'no-cache' }
      }
    });
    return <boolean>JSON.parse(<string>flag.value).enabled;
  }
}
